import React from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
import { formatISOToDDMMYYYY } from "helpers/dateFormat_helper";

const StudentProfileCard = ({ data }) => {
  if (!data) return null;
  const defaultAvatar = "https://cdn-icons-png.flaticon.com/512/149/149071.png";

  return (
    <Card className="mb-4 shadow-sm border-0">
      <CardBody>
        <Row className="align-items-center">
          <Col md="2" className="text-center">
            <img
              src={data.profileImage || defaultAvatar}
              alt={data.name}
              className="rounded-circle img-thumbnail"
              style={{ width: "120px", height: "120px", objectFit: "cover" }}
            />
          </Col>

          <Col md="10">
            <h4 className="fw-bold mb-3">{data.name}</h4>
            <Row>
              <Col md="6">
                <p className="mb-1"><strong>Email:</strong> {data.email}</p>
                <p className="mb-1"><strong>Phone:</strong> {data.phone}</p>
              </Col>
              <Col md="6">
                <p className="mb-1"><strong>Course:</strong> {data.course}</p>
                <p className="mb-1">
                  <strong>Enrollment Date:</strong>{" "}
                  {formatISOToDDMMYYYY(data.enrollmentDate)}
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default StudentProfileCard;
